if (!customElements.get('ws-product-sharing')) {
  customElements.define('ws-product-sharing', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const nativeButton = this.querySelector('[data-native-share]');
      if (nativeButton && typeof navigator.share === 'function') {
        nativeButton.parentElement.hidden = false;
        nativeButton.addEventListener('click', async () => {
          try {
            await navigator.share({ title: this.dataset.title, url: this.dataset.url });
          } catch (error) {
            // Closing the native sheet is not an error to display to the shopper.
            if (error.name !== 'AbortError') console.error('Product sharing failed', error);
          }
        }, { signal: this.controller.signal });
      }
      const copyButton = this.querySelector('[data-copy-link]');
      if (copyButton && navigator.clipboard?.writeText) {
        copyButton.parentElement.hidden = false;
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(this.dataset.url);
            this.querySelector('[data-copy-status]').textContent = this.dataset.copied;
          } catch (error) {
            console.error('Copying product link failed', error);
          }
        }, { signal: this.controller.signal });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
